// Copyright 2025, compose-coui-ui contributors
// SPDX-License-Identifier: Apache-2.0

package io.github.suqi8.coui.kmp.icon.extended

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathNode
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.unit.dp
import io.github.suqi8.coui.kmp.icon.COUIIcons

val COUIIcons.Rename: ImageVector
    get() = COUIIcons.Regular.Rename

val COUIIcons.Light.Rename: ImageVector
    get() {
        if (_renameLight != null) return _renameLight!!
        _renameLight = ImageVector.Builder(
            name = "Rename.Light",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1198.8f,
            viewportHeight = 1198.8f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1198.8f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(987.7f, 198.6f),
                        PathNode.QuadTo(1037.2f, 223.8f, 1062.4f, 273.2f),
                        PathNode.QuadTo(1075.9f, 298.5f, 1078.8f, 335.2f),
                        PathNode.QuadTo(1081.7f, 371.9f, 1081.7f, 460.6f),
                        PathNode.VerticalTo(738.1f),
                        PathNode.QuadTo(1081.7f, 827.8f, 1078.8f, 864.1f),
                        PathNode.QuadTo(1075.9f, 900.3f, 1062.4f, 925.5f),
                        PathNode.QuadTo(1037.2f, 975.0f, 987.7f, 1000.2f),
                        PathNode.QuadTo(963.4f, 1013.7f, 926.2f, 1016.6f),
                        PathNode.QuadTo(889.0f, 1019.6f, 800.3f, 1019.6f),
                        PathNode.HorizontalTo(398.5f),
                        PathNode.QuadTo(309.8f, 1019.6f, 273.0f, 1016.6f),
                        PathNode.QuadTo(236.3f, 1013.7f, 211.1f, 1000.2f),
                        PathNode.QuadTo(161.6f, 975.0f, 136.4f, 925.5f),
                        PathNode.QuadTo(122.9f, 900.3f, 120.0f, 864.1f),
                        PathNode.QuadTo(117.1f, 827.8f, 117.1f, 738.1f),
                        PathNode.VerticalTo(460.6f),
                        PathNode.QuadTo(117.1f, 371.9f, 120.0f, 335.2f),
                        PathNode.QuadTo(122.9f, 298.5f, 136.4f, 273.2f),
                        PathNode.QuadTo(161.6f, 223.8f, 211.1f, 198.6f),
                        PathNode.QuadTo(236.3f, 185.1f, 273.0f, 182.1f),
                        PathNode.QuadTo(309.8f, 179.2f, 398.5f, 179.2f),
                        PathNode.HorizontalTo(800.3f),
                        PathNode.QuadTo(889.0f, 179.2f, 926.2f, 182.1f),
                        PathNode.QuadTo(963.4f, 185.1f, 987.7f, 198.6f),
                        PathNode.Close,
                        PathNode.MoveTo(240.0f, 251.6f),
                        PathNode.QuadTo(223.8f, 259.3f, 210.4f, 273.1f),
                        PathNode.QuadTo(197.1f, 286.8f, 189.4f, 303.1f),
                        PathNode.QuadTo(180.8f, 320.3f, 178.9f, 343.8f),
                        PathNode.QuadTo(177.0f, 367.3f, 177.0f, 419.2f),
                        PathNode.VerticalTo(780.5f),
                        PathNode.QuadTo(177.0f, 832.6f, 178.9f, 856.0f),
                        PathNode.QuadTo(180.8f, 879.5f, 189.4f, 896.6f),
                        PathNode.QuadTo(204.7f, 929.1f, 240.0f, 948.2f),
                        PathNode.QuadTo(258.2f, 956.8f, 281.2f, 958.7f),
                        PathNode.QuadTo(304.2f, 960.6f, 357.1f, 960.6f),
                        PathNode.HorizontalTo(842.7f),
                        PathNode.QuadTo(894.7f, 960.6f, 918.2f, 958.7f),
                        PathNode.QuadTo(941.6f, 956.8f, 958.8f, 948.2f),
                        PathNode.QuadTo(993.2f, 929.1f, 1010.3f, 896.6f),
                        PathNode.QuadTo(1018.9f, 879.5f, 1020.9f, 856.0f),
                        PathNode.QuadTo(1022.8f, 832.6f, 1022.8f, 780.5f),
                        PathNode.VerticalTo(419.2f),
                        PathNode.QuadTo(1022.8f, 367.3f, 1020.9f, 343.8f),
                        PathNode.QuadTo(1018.9f, 320.3f, 1010.3f, 303.1f),
                        PathNode.QuadTo(992.2f, 267.8f, 958.8f, 251.6f),
                        PathNode.QuadTo(941.6f, 243.0f, 918.2f, 241.1f),
                        PathNode.QuadTo(894.7f, 239.1f, 842.7f, 239.1f),
                        PathNode.HorizontalTo(357.1f),
                        PathNode.QuadTo(304.2f, 239.1f, 281.2f, 241.1f),
                        PathNode.QuadTo(258.2f, 243.0f, 240.0f, 251.6f),
                        PathNode.Close,
                        PathNode.MoveTo(468.6f, 345.7f),
                        PathNode.VerticalTo(369.4f),
                        PathNode.QuadTo(468.6f, 377.5f, 463.1f, 382.5f),
                        PathNode.QuadTo(457.6f, 387.5f, 449.5f, 387.5f),
                        PathNode.HorizontalTo(424.8f),
                        PathNode.QuadTo(417.9f, 387.5f, 417.9f, 394.5f),
                        PathNode.VerticalTo(805.3f),
                        PathNode.QuadTo(417.9f, 812.3f, 424.8f, 812.3f),
                        PathNode.HorizontalTo(451.5f),
                        PathNode.QuadTo(459.5f, 812.3f, 464.1f, 817.3f),
                        PathNode.QuadTo(468.6f, 822.4f, 468.6f, 830.3f),
                        PathNode.VerticalTo(852.1f),
                        PathNode.QuadTo(468.6f, 871.2f, 449.5f, 871.2f),
                        PathNode.HorizontalTo(326.2f),
                        PathNode.QuadTo(307.2f, 871.2f, 307.2f, 852.2f),
                        PathNode.VerticalTo(831.3f),
                        PathNode.QuadTo(307.2f, 823.2f, 312.2f, 817.8f),
                        PathNode.QuadTo(317.2f, 812.3f, 324.2f, 812.3f),
                        PathNode.HorizontalTo(351.0f),
                        PathNode.QuadTo(358.0f, 812.3f, 358.0f, 805.3f),
                        PathNode.VerticalTo(394.5f),
                        PathNode.QuadTo(358.0f, 391.5f, 356.0f, 389.5f),
                        PathNode.QuadTo(354.0f, 387.5f, 351.0f, 387.5f),
                        PathNode.HorizontalTo(326.2f),
                        PathNode.QuadTo(318.2f, 387.5f, 312.7f, 382.5f),
                        PathNode.QuadTo(307.2f, 377.5f, 307.2f, 369.4f),
                        PathNode.VerticalTo(345.7f),
                        PathNode.QuadTo(307.2f, 337.6f, 312.7f, 332.6f),
                        PathNode.QuadTo(318.2f, 327.6f, 325.3f, 327.6f),
                        PathNode.HorizontalTo(449.6f),
                        PathNode.QuadTo(458.5f, 327.6f, 463.5f, 332.1f),
                        PathNode.QuadTo(468.6f, 336.7f, 468.6f, 345.7f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _renameLight!!
    }

private var _renameLight: ImageVector? = null

val COUIIcons.Normal.Rename: ImageVector
    get() {
        if (_renameNormal != null) return _renameNormal!!
        _renameNormal = ImageVector.Builder(
            name = "Rename.Normal",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1220.2f,
            viewportHeight = 1220.2f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1220.2f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(1002.3f, 201.3f),
                        PathNode.QuadTo(1054.5f, 227.9f, 1081.1f, 280.1f),
                        PathNode.QuadTo(1094.5f, 306.7f, 1097.8f, 344.4f),
                        PathNode.QuadTo(1101.1f, 382.1f, 1101.1f, 471.5f),
                        PathNode.VerticalTo(748.8f),
                        PathNode.QuadTo(1101.1f, 839.1f, 1097.8f, 876.3f),
                        PathNode.QuadTo(1094.5f, 913.6f, 1081.1f, 940.2f),
                        PathNode.QuadTo(1054.5f, 992.4f, 1002.3f, 1019.0f),
                        PathNode.QuadTo(976.7f, 1032.4f, 938.4f, 1035.7f),
                        PathNode.QuadTo(900.2f, 1039.0f, 810.9f, 1039.0f),
                        PathNode.HorizontalTo(409.4f),
                        PathNode.QuadTo(320.0f, 1039.0f, 282.3f, 1035.7f),
                        PathNode.QuadTo(244.6f, 1032.4f, 218.0f, 1019.0f),
                        PathNode.QuadTo(165.8f, 992.4f, 139.2f, 940.2f),
                        PathNode.QuadTo(125.8f, 913.6f, 122.4f, 876.3f),
                        PathNode.QuadTo(119.2f, 839.1f, 119.2f, 748.8f),
                        PathNode.VerticalTo(471.5f),
                        PathNode.QuadTo(119.2f, 382.1f, 122.4f, 344.4f),
                        PathNode.QuadTo(125.8f, 306.7f, 139.2f, 280.1f),
                        PathNode.QuadTo(165.8f, 227.9f, 218.0f, 201.3f),
                        PathNode.QuadTo(244.6f, 187.9f, 282.3f, 184.5f),
                        PathNode.QuadTo(320.0f, 181.3f, 409.4f, 181.3f),
                        PathNode.HorizontalTo(810.9f),
                        PathNode.QuadTo(900.2f, 181.3f, 938.4f, 184.5f),
                        PathNode.QuadTo(976.7f, 187.9f, 1002.3f, 201.3f),
                        PathNode.Close,
                        PathNode.MoveTo(255.2f, 270.8f),
                        PathNode.QuadTo(240.3f, 278.5f, 228.0f, 290.6f),
                        PathNode.QuadTo(215.7f, 302.6f, 208.7f, 318.2f),
                        PathNode.QuadTo(200.9f, 334.0f, 198.9f, 356.4f),
                        PathNode.QuadTo(197.0f, 378.9f, 197.0f, 430.1f),
                        PathNode.VerticalTo(791.1f),
                        PathNode.QuadTo(197.0f, 843.1f, 198.9f, 865.2f),
                        PathNode.QuadTo(200.9f, 887.3f, 208.7f, 903.0f),
                        PathNode.QuadTo(222.6f, 932.7f, 255.2f, 950.4f),
                        PathNode.QuadTo(271.9f, 958.3f, 293.8f, 960.2f),
                        PathNode.QuadTo(315.8f, 962.2f, 368.0f, 962.2f),
                        PathNode.HorizontalTo(853.2f),
                        PathNode.QuadTo(905.2f, 962.2f, 927.3f, 960.2f),
                        PathNode.QuadTo(949.4f, 958.3f, 965.1f, 950.4f),
                        PathNode.QuadTo(996.7f, 932.7f, 1012.5f, 903.0f),
                        PathNode.QuadTo(1020.4f, 887.3f, 1022.3f, 865.2f),
                        PathNode.QuadTo(1024.3f, 843.1f, 1024.3f, 791.1f),
                        PathNode.VerticalTo(430.1f),
                        PathNode.QuadTo(1024.3f, 378.9f, 1022.3f, 356.4f),
                        PathNode.QuadTo(1020.4f, 334.0f, 1012.5f, 318.2f),
                        PathNode.QuadTo(995.8f, 285.7f, 965.1f, 270.8f),
                        PathNode.QuadTo(949.4f, 263.0f, 927.3f, 261.0f),
                        PathNode.QuadTo(905.2f, 259.1f, 853.2f, 259.1f),
                        PathNode.HorizontalTo(368.0f),
                        PathNode.QuadTo(315.8f, 259.1f, 293.8f, 261.0f),
                        PathNode.QuadTo(271.9f, 263.0f, 255.2f, 270.8f),
                        PathNode.Close,
                        PathNode.MoveTo(485.6f, 353.8f),
                        PathNode.VerticalTo(383.1f),
                        PathNode.QuadTo(485.6f, 394.6f, 478.4f, 401.0f),
                        PathNode.QuadTo(471.2f, 407.4f, 459.6f, 407.4f),
                        PathNode.HorizontalTo(446.7f),
                        PathNode.QuadTo(437.7f, 407.4f, 437.7f, 416.4f),
                        PathNode.VerticalTo(804.8f),
                        PathNode.QuadTo(437.7f, 813.9f, 446.7f, 813.9f),
                        PathNode.HorizontalTo(462.3f),
                        PathNode.QuadTo(473.1f, 813.9f, 479.4f, 821.0f),
                        PathNode.QuadTo(485.6f, 828.1f, 485.6f, 838.2f),
                        PathNode.VerticalTo(864.7f),
                        PathNode.QuadTo(485.6f, 890.7f, 459.6f, 890.7f),
                        PathNode.HorizontalTo(337.2f),
                        PathNode.QuadTo(311.9f, 890.7f, 311.9f, 865.5f),
                        PathNode.VerticalTo(839.1f),
                        PathNode.QuadTo(311.9f, 828.3f, 318.3f, 821.1f),
                        PathNode.QuadTo(324.7f, 813.9f, 334.5f, 813.9f),
                        PathNode.HorizontalTo(350.8f),
                        PathNode.QuadTo(359.9f, 813.9f, 359.9f, 804.8f),
                        PathNode.VerticalTo(416.4f),
                        PathNode.QuadTo(359.9f, 412.7f, 357.6f, 410.1f),
                        PathNode.QuadTo(355.3f, 407.4f, 350.8f, 407.4f),
                        PathNode.HorizontalTo(337.2f),
                        PathNode.QuadTo(326.4f, 407.4f, 319.2f, 400.6f),
                        PathNode.QuadTo(311.9f, 393.9f, 311.9f, 383.1f),
                        PathNode.VerticalTo(353.8f),
                        PathNode.QuadTo(311.9f, 342.3f, 319.2f, 335.9f),
                        PathNode.QuadTo(326.4f, 329.6f, 336.2f, 329.6f),
                        PathNode.HorizontalTo(460.4f),
                        PathNode.QuadTo(471.4f, 329.6f, 478.5f, 335.8f),
                        PathNode.QuadTo(485.6f, 342.1f, 485.6f, 353.8f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _renameNormal!!
    }

private var _renameNormal: ImageVector? = null

val COUIIcons.Regular.Rename: ImageVector
    get() {
        if (_renameRegular != null) return _renameRegular!!
        _renameRegular = ImageVector.Builder(
            name = "Rename.Regular",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1230.0f,
            viewportHeight = 1230.0f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1230.0f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(1008.8f, 202.6f),
                        PathNode.QuadTo(1062.4f, 229.7f, 1089.4f, 283.3f),
                        PathNode.QuadTo(1103.1f, 310.4f, 1106.5f, 348.7f),
                        PathNode.QuadTo(1109.9f, 387.0f, 1109.9f, 476.5f),
                        PathNode.VerticalTo(753.6f),
                        PathNode.QuadTo(1109.9f, 844.0f, 1106.5f, 881.8f),
                        PathNode.QuadTo(1103.1f, 919.6f, 1089.4f, 946.7f),
                        PathNode.QuadTo(1062.4f, 1000.3f, 1008.8f, 1027.4f),
                        PathNode.QuadTo(982.6f, 1041.1f, 943.9f, 1044.4f),
                        PathNode.QuadTo(905.2f, 1047.8f, 815.6f, 1047.8f),
                        PathNode.HorizontalTo(414.4f),
                        PathNode.QuadTo(324.9f, 1047.8f, 286.6f, 1044.4f),
                        PathNode.QuadTo(248.4f, 1041.1f, 221.2f, 1027.4f),
                        PathNode.QuadTo(167.7f, 1000.3f, 140.6f, 946.7f),
                        PathNode.QuadTo(126.9f, 919.6f, 123.5f, 881.8f),
                        PathNode.QuadTo(120.1f, 844.0f, 120.1f, 753.6f),
                        PathNode.VerticalTo(476.5f),
                        PathNode.QuadTo(120.1f, 387.0f, 123.5f, 348.7f),
                        PathNode.QuadTo(126.9f, 310.4f, 140.6f, 283.3f),
                        PathNode.QuadTo(167.7f, 229.7f, 221.2f, 202.6f),
                        PathNode.QuadTo(248.4f, 188.9f, 286.6f, 185.6f),
                        PathNode.QuadTo(324.9f, 182.2f, 414.4f, 182.2f),
                        PathNode.HorizontalTo(815.6f),
                        PathNode.QuadTo(905.2f, 182.2f, 943.9f, 185.6f),
                        PathNode.QuadTo(982.6f, 188.9f, 1008.8f, 202.6f),
                        PathNode.Close,
                        PathNode.MoveTo(262.1f, 279.7f),
                        PathNode.QuadTo(248.0f, 287.3f, 236.2f, 298.7f),
                        PathNode.QuadTo(224.4f, 310.2f, 217.7f, 325.2f),
                        PathNode.QuadTo(210.1f, 340.3f, 208.2f, 362.2f),
                        PathNode.QuadTo(206.4f, 384.1f, 206.4f, 435.1f),
                        PathNode.VerticalTo(795.9f),
                        PathNode.QuadTo(206.4f, 847.7f, 208.2f, 869.2f),
                        PathNode.QuadTo(210.1f, 890.7f, 217.7f, 905.8f),
                        PathNode.QuadTo(231.0f, 934.3f, 262.1f, 951.2f),
                        PathNode.QuadTo(278.2f, 958.8f, 299.7f, 960.7f),
                        PathNode.QuadTo(321.2f, 962.5f, 373.0f, 962.5f),
                        PathNode.HorizontalTo(858.0f),
                        PathNode.QuadTo(909.8f, 962.5f, 931.3f, 960.7f),
                        PathNode.QuadTo(952.7f, 958.8f, 967.9f, 951.2f),
                        PathNode.QuadTo(998.2f, 934.2f, 1013.3f, 905.8f),
                        PathNode.QuadTo(1020.9f, 890.7f, 1022.7f, 869.2f),
                        PathNode.QuadTo(1024.6f, 847.7f, 1024.6f, 795.9f),
                        PathNode.VerticalTo(435.1f),
                        PathNode.QuadTo(1024.6f, 384.1f, 1022.7f, 362.2f),
                        PathNode.QuadTo(1020.9f, 340.3f, 1013.3f, 325.2f),
                        PathNode.QuadTo(997.1f, 294.0f, 967.9f, 279.7f),
                        PathNode.QuadTo(952.7f, 272.1f, 931.3f, 270.3f),
                        PathNode.QuadTo(909.8f, 268.4f, 858.0f, 268.4f),
                        PathNode.HorizontalTo(373.0f),
                        PathNode.QuadTo(321.2f, 268.4f, 299.7f, 270.3f),
                        PathNode.QuadTo(278.2f, 272.1f, 262.1f, 279.7f),
                        PathNode.Close,
                        PathNode.MoveTo(495.2f, 358.8f),
                        PathNode.VerticalTo(391.6f),
                        PathNode.QuadTo(495.2f, 404.5f, 487.4f, 411.4f),
                        PathNode.QuadTo(479.5f, 418.4f, 466.7f, 418.4f),
                        PathNode.HorizontalTo(457.2f),
                        PathNode.QuadTo(447.7f, 418.4f, 447.7f, 427.9f),
                        PathNode.VerticalTo(803.1f),
                        PathNode.QuadTo(447.7f, 812.6f, 457.2f, 812.6f),
                        PathNode.HorizontalTo(469.4f),
                        PathNode.QuadTo(481.3f, 812.6f, 488.3f, 820.4f),
                        PathNode.QuadTo(495.2f, 828.3f, 495.2f, 839.3f),
                        PathNode.VerticalTo(869.4f),
                        PathNode.QuadTo(495.2f, 897.9f, 466.7f, 897.9f),
                        PathNode.HorizontalTo(342.4f),
                        PathNode.QuadTo(314.7f, 897.9f, 314.7f, 870.2f),
                        PathNode.VerticalTo(840.3f),
                        PathNode.QuadTo(314.7f, 828.3f, 321.6f, 820.4f),
                        PathNode.QuadTo(328.5f, 812.6f, 339.6f, 812.6f),
                        PathNode.HorizontalTo(352.8f),
                        PathNode.QuadTo(362.3f, 812.6f, 362.3f, 803.1f),
                        PathNode.VerticalTo(427.9f),
                        PathNode.QuadTo(362.3f, 424.0f, 359.9f, 421.2f),
                        PathNode.QuadTo(357.5f, 418.4f, 352.8f, 418.4f),
                        PathNode.HorizontalTo(342.4f),
                        PathNode.QuadTo(330.3f, 418.4f, 322.5f, 411.0f),
                        PathNode.QuadTo(314.7f, 403.7f, 314.7f, 391.6f),
                        PathNode.VerticalTo(358.8f),
                        PathNode.QuadTo(314.7f, 346.1f, 322.5f, 339.1f),
                        PathNode.QuadTo(330.3f, 332.1f, 341.4f, 332.1f),
                        PathNode.HorizontalTo(467.5f),
                        PathNode.QuadTo(479.5f, 332.1f, 487.4f, 339.0f),
                        PathNode.QuadTo(495.2f, 346.0f, 495.2f, 358.8f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _renameRegular!!
    }

private var _renameRegular: ImageVector? = null

val COUIIcons.Medium.Rename: ImageVector
    get() {
        if (_renameMedium != null) return _renameMedium!!
        _renameMedium = ImageVector.Builder(
            name = "Rename.Medium",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1249.8f,
            viewportHeight = 1249.8f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1249.8f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(1022.0f, 205.7f),
                        PathNode.QuadTo(1078.5f, 233.3f, 1106.1f, 289.8f),
                        PathNode.QuadTo(1121.0f, 318.1f, 1124.3f, 357.6f),
                        PathNode.QuadTo(1127.7f, 397.0f, 1127.7f, 486.4f),
                        PathNode.VerticalTo(763.3f),
                        PathNode.QuadTo(1127.7f, 853.7f, 1124.3f, 892.7f),
                        PathNode.QuadTo(1121.0f, 931.6f, 1106.1f, 959.9f),
                        PathNode.QuadTo(1078.5f, 1016.4f, 1022.0f, 1044.0f),
                        PathNode.QuadTo(994.6f, 1058.9f, 955.1f, 1062.3f),
                        PathNode.QuadTo(915.5f, 1065.7f, 825.4f, 1065.7f),
                        PathNode.HorizontalTo(424.4f),
                        PathNode.QuadTo(335.0f, 1065.7f, 295.5f, 1062.3f),
                        PathNode.QuadTo(256.1f, 1058.9f, 227.8f, 1044.0f),
                        PathNode.QuadTo(171.3f, 1016.4f, 143.6f, 959.9f),
                        PathNode.QuadTo(128.7f, 931.6f, 125.4f, 892.7f),
                        PathNode.QuadTo(122.0f, 853.7f, 122.0f, 763.3f),
                        PathNode.VerticalTo(486.4f),
                        PathNode.QuadTo(122.0f, 397.0f, 125.4f, 357.6f),
                        PathNode.QuadTo(128.7f, 318.1f, 143.6f, 289.8f),
                        PathNode.QuadTo(171.3f, 233.3f, 227.8f, 205.7f),
                        PathNode.QuadTo(256.1f, 190.8f, 295.5f, 187.4f),
                        PathNode.QuadTo(335.0f, 184.0f, 424.4f, 184.0f),
                        PathNode.HorizontalTo(825.4f),
                        PathNode.QuadTo(915.5f, 184.0f, 955.1f, 187.4f),
                        PathNode.QuadTo(994.6f, 190.8f, 1022.0f, 205.7f),
                        PathNode.Close,
                        PathNode.MoveTo(275.8f, 296.9f),
                        PathNode.QuadTo(262.8f, 303.9f, 252.2f, 314.7f),
                        PathNode.QuadTo(241.6f, 325.5f, 234.8f, 338.8f),
                        PathNode.QuadTo(227.9f, 352.7f, 226.3f, 373.4f),
                        PathNode.QuadTo(224.8f, 394.1f, 224.8f, 445.1f),
                        PathNode.VerticalTo(805.7f),
                        PathNode.QuadTo(224.8f, 856.9f, 226.3f, 877.4f),
                        PathNode.QuadTo(227.9f, 898.0f, 234.8f, 912.0f),
                        PathNode.QuadTo(247.6f, 938.7f, 275.8f, 953.8f),
                        PathNode.QuadTo(290.7f, 960.8f, 311.3f, 962.3f),
                        PathNode.QuadTo(331.8f, 963.9f, 383.0f, 963.9f),
                        PathNode.HorizontalTo(867.7f),
                        PathNode.QuadTo(918.9f, 963.9f, 939.4f, 962.3f),
                        PathNode.QuadTo(960.0f, 960.8f, 974.0f, 953.8f),
                        PathNode.QuadTo(1001.9f, 937.9f, 1015.8f, 912.0f),
                        PathNode.QuadTo(1022.8f, 898.0f, 1024.3f, 877.4f),
                        PathNode.QuadTo(1025.9f, 856.9f, 1025.9f, 805.7f),
                        PathNode.VerticalTo(445.1f),
                        PathNode.QuadTo(1025.9f, 394.1f, 1024.3f, 373.4f),
                        PathNode.QuadTo(1022.8f, 352.7f, 1015.8f, 338.8f),
                        PathNode.QuadTo(1000.2f, 310.6f, 974.0f, 296.9f),
                        PathNode.QuadTo(960.0f, 289.9f, 939.4f, 288.3f),
                        PathNode.QuadTo(918.9f, 286.8f, 867.7f, 286.8f),
                        PathNode.HorizontalTo(383.0f),
                        PathNode.QuadTo(331.8f, 286.8f, 311.3f, 288.3f),
                        PathNode.QuadTo(290.7f, 289.9f, 275.8f, 296.9f),
                        PathNode.Close,
                        PathNode.MoveTo(518.7f, 372.4f),
                        PathNode.VerticalTo(414.6f),
                        PathNode.QuadTo(518.7f, 429.3f, 510.3f, 437.1f),
                        PathNode.QuadTo(501.9f, 444.9f, 487.3f, 444.9f),
                        PathNode.HorizontalTo(478.4f),
                        PathNode.QuadTo(469.4f, 444.9f, 469.4f, 453.8f),
                        PathNode.VerticalTo(796.9f),
                        PathNode.QuadTo(469.4f, 805.8f, 478.4f, 805.8f),
                        PathNode.HorizontalTo(489.4f),
                        PathNode.QuadTo(503.1f, 805.8f, 510.9f, 814.2f),
                        PathNode.QuadTo(518.7f, 822.6f, 518.7f, 836.0f),
                        PathNode.VerticalTo(876.1f),
                        PathNode.QuadTo(518.7f, 907.6f, 487.3f, 907.6f),
                        PathNode.HorizontalTo(353.0f),
                        PathNode.QuadTo(321.7f, 907.6f, 321.7f, 876.4f),
                        PathNode.VerticalTo(837.0f),
                        PathNode.QuadTo(321.7f, 822.6f, 329.5f, 814.2f),
                        PathNode.QuadTo(337.4f, 805.8f, 350.8f, 805.8f),
                        PathNode.HorizontalTo(362.8f),
                        PathNode.QuadTo(371.7f, 805.8f, 371.7f, 796.9f),
                        PathNode.VerticalTo(453.8f),
                        PathNode.QuadTo(371.7f, 450.0f, 369.3f, 447.4f),
                        PathNode.QuadTo(366.9f, 444.9f, 362.8f, 444.9f),
                        PathNode.HorizontalTo(353.0f),
                        PathNode.QuadTo(338.6f, 444.9f, 330.1f, 437.0f),
                        PathNode.QuadTo(321.7f, 429.0f, 321.7f, 414.6f),
                        PathNode.VerticalTo(372.4f),
                        PathNode.QuadTo(321.7f, 358.5f, 330.1f, 350.3f),
                        PathNode.QuadTo(338.6f, 342.2f, 352.0f, 342.2f),
                        PathNode.HorizontalTo(487.5f),
                        PathNode.QuadTo(501.9f, 342.2f, 510.3f, 350.0f),
                        PathNode.QuadTo(518.7f, 357.7f, 518.7f, 372.4f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _renameMedium!!
    }

private var _renameMedium: ImageVector? = null

val COUIIcons.Demibold.Rename: ImageVector
    get() {
        if (_renameDemibold != null) return _renameDemibold!!
        _renameDemibold = ImageVector.Builder(
            name = "Rename.Demibold",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1263.6f,
            viewportHeight = 1263.6f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1263.6f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(1031.2f, 207.8f),
                        PathNode.QuadTo(1089.7f, 235.9f, 1117.8f, 294.4f),
                        PathNode.QuadTo(1133.5f, 323.6f, 1136.8f, 363.8f),
                        PathNode.QuadTo(1140.2f, 404.0f, 1140.2f, 493.4f),
                        PathNode.VerticalTo(770.2f),
                        PathNode.QuadTo(1140.2f, 860.5f, 1136.8f, 900.3f),
                        PathNode.QuadTo(1133.5f, 940.0f, 1117.8f, 969.2f),
                        PathNode.QuadTo(1089.7f, 1027.7f, 1031.2f, 1055.8f),
                        PathNode.QuadTo(1003.0f, 1071.5f, 962.8f, 1074.8f),
                        PathNode.QuadTo(922.7f, 1078.2f, 832.2f, 1078.2f),
                        PathNode.HorizontalTo(431.4f),
                        PathNode.QuadTo(342.0f, 1078.2f, 301.8f, 1074.8f),
                        PathNode.QuadTo(261.6f, 1071.5f, 232.4f, 1055.8f),
                        PathNode.QuadTo(173.9f, 1027.7f, 145.8f, 969.2f),
                        PathNode.QuadTo(130.1f, 940.0f, 126.8f, 900.3f),
                        PathNode.QuadTo(123.4f, 860.5f, 123.4f, 770.2f),
                        PathNode.VerticalTo(493.4f),
                        PathNode.QuadTo(123.4f, 404.0f, 126.8f, 363.8f),
                        PathNode.QuadTo(130.1f, 323.6f, 145.8f, 294.4f),
                        PathNode.QuadTo(173.9f, 235.9f, 232.4f, 207.8f),
                        PathNode.QuadTo(261.6f, 192.1f, 301.8f, 188.8f),
                        PathNode.QuadTo(342.0f, 185.4f, 431.4f, 185.4f),
                        PathNode.HorizontalTo(832.2f),
                        PathNode.QuadTo(922.7f, 185.4f, 962.8f, 188.8f),
                        PathNode.QuadTo(1003.0f, 192.1f, 1031.2f, 207.8f),
                        PathNode.Close,
                        PathNode.MoveTo(285.3f, 308.9f),
                        PathNode.QuadTo(273.2f, 315.5f, 263.4f, 325.9f),
                        PathNode.QuadTo(253.7f, 336.3f, 246.9f, 348.3f),
                        PathNode.QuadTo(240.4f, 361.4f, 239.0f, 381.2f),
                        PathNode.QuadTo(237.7f, 401.1f, 237.7f, 452.0f),
                        PathNode.VerticalTo(812.5f),
                        PathNode.QuadTo(237.7f, 863.3f, 239.0f, 883.2f),
                        PathNode.QuadTo(240.4f, 903.1f, 246.9f, 916.2f),
                        PathNode.QuadTo(259.2f, 941.7f, 285.3f, 955.6f),
                        PathNode.QuadTo(299.4f, 962.2f, 319.3f, 963.6f),
                        PathNode.QuadTo(339.3f, 964.9f, 390.0f, 964.9f),
                        PathNode.HorizontalTo(874.5f),
                        PathNode.QuadTo(925.3f, 964.9f, 945.2f, 963.6f),
                        PathNode.QuadTo(965.1f, 962.2f, 978.2f, 955.6f),
                        PathNode.QuadTo(1004.5f, 940.6f, 1017.6f, 916.2f),
                        PathNode.QuadTo(1024.2f, 903.1f, 1025.5f, 883.2f),
                        PathNode.QuadTo(1026.9f, 863.3f, 1026.9f, 812.5f),
                        PathNode.VerticalTo(452.0f),
                        PathNode.QuadTo(1026.9f, 401.1f, 1025.5f, 381.2f),
                        PathNode.QuadTo(1024.2f, 361.4f, 1017.6f, 348.3f),
                        PathNode.QuadTo(1002.4f, 322.2f, 978.2f, 308.9f),
                        PathNode.QuadTo(965.1f, 302.4f, 945.2f, 301.0f),
                        PathNode.QuadTo(925.3f, 299.6f, 874.5f, 299.6f),
                        PathNode.HorizontalTo(390.0f),
                        PathNode.QuadTo(339.3f, 299.6f, 319.3f, 301.0f),
                        PathNode.QuadTo(299.4f, 302.4f, 285.3f, 308.9f),
                        PathNode.Close,
                        PathNode.MoveTo(535.2f, 381.9f),
                        PathNode.VerticalTo(430.7f),
                        PathNode.QuadTo(535.2f, 446.6f, 526.4f, 455.0f),
                        PathNode.QuadTo(517.6f, 463.4f, 501.7f, 463.4f),
                        PathNode.HorizontalTo(493.2f),
                        PathNode.QuadTo(484.7f, 463.4f, 484.7f, 471.9f),
                        PathNode.VerticalTo(792.6f),
                        PathNode.QuadTo(484.7f, 801.1f, 493.2f, 801.1f),
                        PathNode.HorizontalTo(503.4f),
                        PathNode.QuadTo(518.4f, 801.1f, 526.8f, 809.9f),
                        PathNode.QuadTo(535.2f, 818.7f, 535.2f, 833.8f),
                        PathNode.VerticalTo(880.9f),
                        PathNode.QuadTo(535.2f, 914.4f, 501.7f, 914.4f),
                        PathNode.HorizontalTo(360.4f),
                        PathNode.QuadTo(326.8f, 914.4f, 326.8f, 880.7f),
                        PathNode.VerticalTo(834.8f),
                        PathNode.QuadTo(326.8f, 818.7f, 335.2f, 809.9f),
                        PathNode.QuadTo(343.6f, 801.1f, 358.7f, 801.1f),
                        PathNode.HorizontalTo(369.9f),
                        PathNode.QuadTo(378.3f, 801.1f, 378.3f, 792.6f),
                        PathNode.VerticalTo(471.9f),
                        PathNode.QuadTo(378.3f, 468.1f, 375.9f, 465.8f),
                        PathNode.QuadTo(373.5f, 463.4f, 369.9f, 463.4f),
                        PathNode.HorizontalTo(360.4f),
                        PathNode.QuadTo(344.4f, 463.4f, 335.6f, 455.1f),
                        PathNode.QuadTo(326.8f, 446.8f, 326.8f, 430.7f),
                        PathNode.VerticalTo(381.9f),
                        PathNode.QuadTo(326.8f, 367.2f, 335.6f, 358.2f),
                        PathNode.QuadTo(344.4f, 349.2f, 359.5f, 349.2f),
                        PathNode.HorizontalTo(501.5f),
                        PathNode.QuadTo(517.6f, 349.2f, 526.4f, 357.6f),
                        PathNode.QuadTo(535.2f, 366.1f, 535.2f, 381.9f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _renameDemibold!!
    }

private var _renameDemibold: ImageVector? = null
